module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }